export default __webpack_public_path__ + "static/media/Gatronova.9527dc09.jpeg";